// <reference path="/node_modules/@angular/core/index.d.ts" />

import { Injectable, Inject } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
//import {Configuration} from '../Constants/index';
import {Configuration} from '../Shared/Constants/app.constants';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { of } from 'rxjs/observable/of';

import { AuthHttp } from 'angular2-jwt';
// Import RxJs required methods
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { environment } from '../../environments/environment';

import {TreeModule, TreeNode} from 'primeng/primeng';


@Injectable()
export class SeedDataService {
    
    private readonly APIEndPoint: any = environment.apiEndPoint;
    private keyValueCache = new Map<string, any>();
    private lovCache = new Map<string, any>();   // persistent – survives logout
    // private actionUrl: string = "http://172.16.6.110:2016/api/";
    private actionUrl: string = environment.apiEndPoint +  "/api/";
    private headers: Headers;
    private apiUrl: string;
    


    constructor(private http: Http, private authHttp: AuthHttp) {
        this.headers = new Headers();
        this.headers.append('Content-Type', 'application/json');
        this.headers.append('Accept', 'application/json');
        this.headers.append("Access-Control-Allow-Origin", "*");
    }

    clearCache() {
        this.keyValueCache.clear();
        // lovCache is intentionally NOT cleared here so LOV data survives logout
    }

    clearLovCache() {
        this.lovCache.clear();
    }

    clearLegacyLocalStorageCache() {
    }

    getLOVType() {
        const cacheKey = 'LOVType';
        if (this.lovCache.has(cacheKey)) { return of(this.lovCache.get(cacheKey)); }
        this.apiUrl = this.APIEndPoint +  '/api/LOV/getLOVType';
        return this.authHttp.get(this.apiUrl).map((res: Response) => {
            let data = this.renamePropertyNames(JSON.stringify(res.json()));
            this.lovCache.set(cacheKey, data);
            return data;
        });
    }
	getLOVTypeByID(id: any) {
        const cacheKey = `LOVTypeByID_${id}`;
        if (this.lovCache.has(cacheKey)) { return of(this.lovCache.get(cacheKey)); }
        this.apiUrl = this.APIEndPoint +  '/api/LOV/getLOVTypeByID?ID=' + id;
        return this.authHttp.get(this.apiUrl).map((res: Response) => {
            const data = res.json();
            this.lovCache.set(cacheKey, data);
            return data;
        });
    }
	getLOVByType(typeID: any) {
        const cacheKey = `LOVByType_${typeID}`;
        if (this.lovCache.has(cacheKey)) { return of(this.lovCache.get(cacheKey)); }
        this.apiUrl = this.APIEndPoint +  '/api/LOV/getLOVByType?lovTypeID=' + typeID + '';
        return this.authHttp.get(this.apiUrl).map((res: Response) => {
            const data = res.json();
            this.lovCache.set(cacheKey, data);
            return data;
        });
    }

  
	getLOVByTypeName(lovTypeName: any) {
        const cacheKey = `LOVByTypeName_${lovTypeName}`;
        if (this.lovCache.has(cacheKey)) { return of(this.lovCache.get(cacheKey)); }
        this.apiUrl = this.APIEndPoint + '/api/LOV/getLOVByTypeName?lovTypeName=' + lovTypeName;
        return this.authHttp.get(this.apiUrl).map((res: Response) => {
            const data = res.json();
            this.lovCache.set(cacheKey, data);
            return data;
        });
    }




    getHomeLocationLOV(lovTypeName: any) {
        const cacheKey = `HomeLocationLOV_${lovTypeName}`;
        if (this.lovCache.has(cacheKey)) { return of(this.lovCache.get(cacheKey)); }
        this.apiUrl = this.APIEndPoint +  '/api/LOV/getHomeLocationLOV?lovTypeName=' + lovTypeName + '';
        return this.authHttp.get(this.apiUrl).map((res: Response) => {
            const data = res.json();
            this.lovCache.set(cacheKey, data);
            return data;
        });
    }

	getLOVByTypeForBinding(typeID: any, _firstOption: any, _fieldForSave: any, _inputType: any) {
        const cacheKey = `LOVForBinding_${typeID}_${_firstOption}_${_fieldForSave}_${_inputType}`;
        if (this.lovCache.has(cacheKey)) { return of(this.lovCache.get(cacheKey)); }
        this.apiUrl = this.APIEndPoint +  '/api/LOV/getLOVByType?lovTypeID=' + typeID + '';
        return this.authHttp.get(this.apiUrl).map((res: Response) => {
            const data = this.renamePropertyNamesForBinding(JSON.stringify(res.json()), _firstOption, _fieldForSave, _inputType);
            this.lovCache.set(cacheKey, data);
            return data;
        });
    }

    getClients() {
        const cacheKey = 'Clients';
        if (this.lovCache.has(cacheKey)) { return of(this.lovCache.get(cacheKey)); }
        this.apiUrl = this.APIEndPoint +  '/api/LOV/getClients';
        return this.authHttp.get(this.apiUrl).map((res: Response) => {
            const data = res.json();
            this.lovCache.set(cacheKey, data);
            return data;
        });
    }

    getClientsByDepartmentID(departmentID: any) {
        const cacheKey = `ClientsByDept_${departmentID}`;
        if (this.lovCache.has(cacheKey)) { return of(this.lovCache.get(cacheKey)); }
        this.apiUrl = this.APIEndPoint +  '/api/LOV/getClients?departmentID='+ departmentID;
        return this.authHttp.get(this.apiUrl).map((res: Response) => {
            const data = res.json();
            this.lovCache.set(cacheKey, data);
            return data;
        });
    }

    getPractices() {
        const cacheKey = 'Practices';
        if (this.lovCache.has(cacheKey)) { return of(this.lovCache.get(cacheKey)); }
        this.apiUrl = this.APIEndPoint +  '/api/LOV/getPractices';
        return this.authHttp.get(this.apiUrl).map((res: Response) => {
            const data = res.json();
            this.lovCache.set(cacheKey, data);
            return data;
        });
    }

    getPracticesByDepartmentID(departmentID: any) {
        const cacheKey = `PracticesByDept_${departmentID}`;
        if (this.lovCache.has(cacheKey)) { return of(this.lovCache.get(cacheKey)); }
        this.apiUrl = this.APIEndPoint +  '/api/LOV/getPractices?departmentID=' + departmentID;
        return this.authHttp.get(this.apiUrl).map((res: Response) => {
            const data = res.json();
            this.lovCache.set(cacheKey, data);
            return data;
        });
    }
    
     getExpertiseList(newDepartmentID: any) {
         const cacheKey = `ExpertiseList_${newDepartmentID}`;
         if (this.lovCache.has(cacheKey)) { return of(this.lovCache.get(cacheKey)); }
         this.apiUrl = this.APIEndPoint +  '/api/LOV/getExpertiseList?departmentID=' + newDepartmentID;
         return this.authHttp.get(this.apiUrl).map((res: Response) => {
             const data = res.json();
             this.lovCache.set(cacheKey, data);
             return data;
         });
     }
    

	renamePropertyNamesForBinding(json: any, _firstOption: any, _fieldForSave: any, _inputType: any) {

        let fieldForSave = "id";
        if (_fieldForSave) {
            if (_fieldForSave == "label") {
                fieldForSave = "name";
            }
        }

        var obj = JSON.parse(json);
        if (obj != null && obj != undefined && obj != '') {
            var objddl = [];

            if (_inputType != 'multiselect') {
                objddl.push({ 'label': _firstOption, 'value': '' })
            }

            for (var i = 0; i < obj.length; i++) {
                if (obj[i].hasOwnProperty("name")) {
                    objddl.push({ 'label': obj[i]["name"], 'value': obj[i][fieldForSave] });
                }
            }
        }
        return objddl;
    }

	renamePropertyNames(json: any) {
        var obj = JSON.parse(json);
        for (var i = 0; i < obj.length; i++) {
            if (obj[i].hasOwnProperty("lovType")) {
                obj[i]["label"] = obj[i]["displayName"];
                delete obj[i]["displayName"];
         }
            if (obj[i].hasOwnProperty("id")) {
                obj[i]["value"] = obj[i]["id"];
                delete obj[i]["id"];
            }
        }
        return obj;
    }

	SaveLOV(lovData: any) {
        this.apiUrl = this.APIEndPoint +  '/api/LOV/SaveLOV';
        console.log("this is root url", this.apiUrl)
        let requestOption = new RequestOptions({ headers: this.headers });
        return this.authHttp.post(this.apiUrl, lovData, requestOption).map((res: Response) => {
            let data = res.json();
            return data;
        })
    }

    EditLOV(LOVTypeID: string, ID: string, Name: string) {
        this.apiUrl = this.APIEndPoint +  '/api/LOV/SaveLOV';
        let requestOption = new RequestOptions({ headers: this.headers });
        let body = JSON.stringify({ LOVTypeID, ID, Name });
        return this.authHttp.post(this.apiUrl, body, requestOption).map((res: Response) => {
            let data = res.json();
            return data;
        })
    }

    DeleteLOV(ID: string) {
        this.apiUrl = '/api/LOV/DeleteLOV';
        let requestOption = new RequestOptions({ headers: this.headers });
        let body = JSON.stringify({ ID });

        return this.authHttp.post(this.apiUrl, body, requestOption).map((res: Response) => {
            let data = res.json();
            return data;
        })
    }

	getLOVByID(lovID: any) {
        const cacheKey = `LOVByID_${lovID}`;
        if (this.lovCache.has(cacheKey)) { return of(this.lovCache.get(cacheKey)); }
        this.apiUrl = this.APIEndPoint +  '/api/LOV/getLOVByID?lovID=' + lovID + '';
        return this.authHttp.get(this.apiUrl).map((res) => {
            const data = res.json();
            this.lovCache.set(cacheKey, data);
            return data;
        });
    }

    getLOVAccessTypes() {
        const cacheKey = 'LOVAccessTypes';
        if (this.lovCache.has(cacheKey)) { return of(this.lovCache.get(cacheKey)); }
        this.apiUrl = this.APIEndPoint +  '/api/LOV/getLOVAccessTypes';
        return this.authHttp.get(this.apiUrl).map((res) => {
            const data = res.json();
            this.lovCache.set(cacheKey, data);
            return data;
        });
    }
    // Sunil Code End

    GetDeliveryUnitDataWithoutTreeForm(ID: any) {
        if (ID == undefined) {
            ID = 0;
        }
        this.apiUrl = this.APIEndPoint +  '/api/DeliveryUnit/GetDeliveryUnit';
        let requestOption = new RequestOptions({ headers: this.headers }); // Create a request option
        var jwt = window.localStorage.getItem('id_token');
        var authHeader = new Headers();
        if (jwt) {
            authHeader.append('Authorization', 'Bearer ' + jwt);
        }
        return this.authHttp.get(this.APIEndPoint +  '/api/DeliveryUnit/GetDeliveryUnitWithoutTreeForm?id=' + ID, { headers: authHeader }).map((res: Response) => {
            let data = res.json();
            return data;
        });
    }

    GetDeliveryUnitData(ID: any) {

        if (ID == undefined) {

            ID = 0;
        }
        this.apiUrl = this.APIEndPoint +  '/api/DeliveryUnit/GetDeliveryUnit';
        let requestOption = new RequestOptions({ headers: this.headers }); // Create a request option

        var jwt = window.localStorage.getItem('id_token');
        var authHeader = new Headers();
        if (jwt) {
            authHeader.append('Authorization', 'Bearer ' + jwt);
        }

        return this.authHttp.get(this.APIEndPoint +  '/api/DeliveryUnit/GetDeliveryUnit?id=' + ID, { headers: authHeader }).map((res: Response) => {

            let data = res.json();
            
            let treeData = this.ConvertFlatJsonToHierarchicalTree(data);
            return treeData;
        });
    }
    //Added By Ajay Patel On 01-29-2018
    GetAllDeliveryUnits() {

        this.apiUrl = this.APIEndPoint +  '/api/DeliveryUnit/GetDeliveryUnit';
        let requestOption = new RequestOptions({ headers: this.headers }); // Create a request option

        var jwt = window.localStorage.getItem('id_token');
        var authHeader = new Headers();
        if (jwt) {
            authHeader.append('Authorization', 'Bearer ' + jwt);
        }

        return this.authHttp.get(this.APIEndPoint +  '/api/DeliveryUnit/GetDeliveryUnit?id=0', { headers: authHeader }).map((res: Response) => {

            let data = res.json();
            return data;
        });
    }
    //Added By Ajay Patel On 01-29-2018
    GetHRList() {

        this.apiUrl = this.APIEndPoint +  '/api/LOV/getHRList';
        let requestOption = new RequestOptions({ headers: this.headers }); // Create a request option

        var jwt = window.localStorage.getItem('id_token');
        var authHeader = new Headers();
        if (jwt) {
            authHeader.append('Authorization', 'Bearer ' + jwt);
        }

        return this.authHttp.get(this.APIEndPoint +  '/api/LOV/getHRList', { headers: authHeader }).map((res: Response) => {
            let data = res.json();
            return data;
        });
    }
	SaveDeliveryUnitData(ParentID: any, Name: any, ID: any, HRBusinessParterID: any, UnitManagerID: any) {

        this.apiUrl = this.APIEndPoint +  '/api/DeliveryUnit/SaveDeliveryUnit';
        let requestOption = new RequestOptions({ headers: this.headers });
        let body = JSON.stringify({ ParentID, Name, ID, HRBusinessParterID, UnitManagerID });
        console.log(body);
        return this.authHttp.post(this.apiUrl, body, requestOption).map((res: Response) => {
            let data = res.json();
            return data;
        });
    }

	DeleteDeliveryUnitData(ID: any) {

        this.apiUrl = this.APIEndPoint +  '/api/DeliveryUnit/DeleteDeliveryUnit';
        let requestOption = new RequestOptions({ headers: this.headers });
        let body = JSON.stringify({ ID });
        console.log(body);
        return this.authHttp.post(this.apiUrl, body, requestOption).map((res: Response) => {
            let data = res.json();
            return data;
        });
    }

    //---------- Added By Shweta -------------

    // getTravelType() {
    //     this.apiUrl = this.APIEndPoint +  '/api/LOV/getTravelType';
    //     return this.authHttp.get(this.apiUrl).map((res: Response) => {
    //         let data = res.json();
    //         return data
    //     });
    // }

//  getTravelPurpose() {
//         this.apiUrl = this.APIEndPoint +  '/api/LOV/getTravelPurpose';
//         return this.authHttp.get(this.apiUrl).map((res: Response) => {
//             let data = res.json();
//             return data
//         });
//     }
    // getGetCountryVisited() {
    //     this.apiUrl = this.APIEndPoint +  '/api/LOV/getGetCountryVisited';
    //     return this.authHttp.get(this.apiUrl).map((res: Response) => {
    //         let data = res.json();
    //         return data
    //     });
    // }
// getBgVerificationStatus() {
//         this.apiUrl = this.APIEndPoint +  '/api/LOV/getBgVerificationStatus';
//         return this.authHttp.get(this.apiUrl).map((res: Response) => {
//             let data = res.json();
//             return data
//         });
//     }


    
// getBgStatusCode() {
//         this.apiUrl = this.APIEndPoint +  '/api/LOV/getBgStatusCode';
//         return this.authHttp.get(this.apiUrl).map((res: Response) => {
//             let data = res.json();
//             return data
//         });
//     }
// getBgVerificationDoneBy() {
//         this.apiUrl = this.APIEndPoint +  '/api/LOV/getBgVerificationDoneBy';
//         return this.authHttp.get(this.apiUrl).map((res: Response) => {
//             let data = res.json();
//             return data
//         });
//     }
    //   getContractPurpose() {
    //     this.apiUrl = this.APIEndPoint +  '/api/LOV/getContractPurpose';
    //     return this.authHttp.get(this.apiUrl).map((res: Response) => {
    //         let data = res.json();
    //         return data
    //     });
    // }
    //   getContractType() {
    //     this.apiUrl = this.APIEndPoint +  '/api/LOV/getContractType';
    //     return this.authHttp.get(this.apiUrl).map((res: Response) => {
    //         let data = res.json();
    //         return data
    //     });
    // }

    //---------- End ------------------------


    getFiles() {

        return this.http.get(this.APIEndPoint +  '/api/DeliveryUnit/GetDeliveryUnit?id=0').map((res: Response) => {

            let data = res.json();
            console.log(data);
            let treeData = this.ConvertFlatJsonToHierarchicalTree(data);
            return treeData;

        });

    }
	GetKeyValue(Name: any) {
         const cacheKey = `KeyValue_${Name}`;

         if (this.keyValueCache.has(cacheKey)) {
             return of(this.keyValueCache.get(cacheKey));
         }

         this.apiUrl = this.APIEndPoint + '/api/LOV/GetKeyValueName?Name=' + Name;
         return this.authHttp.get(this.apiUrl).map((res: Response) => {
             const data = res.json();
             this.keyValueCache.set(cacheKey, data);
             return data;
         });
    }
	private ConvertFlatJsonToHierarchicalTree(data: any) {
		var tree: any[] = [];
        //create a name: node map
		var dataMap = data.reduce(function (map: any, node: any) {
            node["label"] = node.name;
            node["data"] = node.name + " Folder";
            node["expandedIcon"] = "fa-folder-open";
            node["collapsedIcon"] = "fa-folder";
            map[node.id] = node;
            return map;
        }, {});


        // create the tree array
		data.forEach(function (node: any) {
            // find parent                   
            var parent = dataMap[node.parentID];

            if (parent) {
                // create child array if it doesn't exist
                (parent.children || (parent.children = []))
                    // add node to parent's child array
                    .push(node);

            } else {
                // parent is null or missing
                tree.push(node);
            }
        });

        return tree;

    }

    private handleError(error: any) {
        // log error
        // could be something more sofisticated
        console.log("error message= " + error.message);
        let errorMsg = error.message || 'There was was a problem with our REST Service and we couldnt retrieve data!';


        // throw an application level error
        return Observable.throw(errorMsg);
    }
    GetMissingPriorRelevantExperience(){
        this.apiUrl = this.APIEndPoint +  '/api/TeamMember/GetMissingPriorRelevantExperience';
        return this.authHttp.get(this.apiUrl).map((res: Response) => {
            let data = res.json();
            return data
        });
    }
    UpdatePriorRelevantExperience(SavepriorRelevantExperiences: any) {
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        let body = JSON.stringify(SavepriorRelevantExperiences);
        const apiUrl = `${this.APIEndPoint}/api/TeamMember/SavepriorRelevantExperiences`;
        //const requestOptions = new RequestOptions({ headers: this.headers });
        const data = JSON.stringify(SavepriorRelevantExperiences);
    
        return this.authHttp.post(apiUrl, body,options).map((res: Response) => {
            return res.json();
        });
    }


}




// WEBPACK FOOTER //
// ./src/app/Services/seeddata.service.ts